import { useMemo } from 'react'

import { useAppSelector } from '@store/hooks'
import { selectCurrentUser } from '@store/modules/session/slice'

/*
  useRole hook used for:
  - check if user has admin or super_admin role (isAdmin, isSuperAdmin)
  Access checks use permission keys (`@features/permissions/permissions`), never the role.

  Example:
  const { isAdmin, isSuperAdmin } = useRole()
*/
export function useRole() {
  const user = useAppSelector(selectCurrentUser)

  // User roles
  const role = user?.role ?? ''
  const isAdmin = role === 'admin'
  const isSuperAdmin = role === 'super_admin'

  return useMemo(
    () => ({
      user,

      isAdmin,
      isSuperAdmin,
    }),
    [isAdmin, isSuperAdmin, user],
  )
}
